// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataxaut0 } from "../../../icons/mono/build/icon-stataxaut0.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataxautZeroIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataxaut0.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataxautZeroIcon.displayName = 'StataxautZeroIcon';
}

export default StataxautZeroIcon;